import { timeSheetsApi } from 'Api/timeSheet';
import dayjs from 'dayjs';
import { TablePagination, TableSorter } from 'interfaces/global.interface';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CloseSvg } from 'utils/svgs';
import { toastText } from 'utils/utils';
import TimeSheetsTableHeader from './Table/Header/index';
import TimeSheetsTable from './Table/TimeSheetsTable';
import styles from './index.module.scss';

const TimeSheetComponent = () => {
	const navigate = useNavigate();

	const [timeSheetData, setTimeSheetData] = useState([]);
	const [totalRecords, setTotalRecords] = useState(0);
	const [isLoading, setIsLoading] = useState(false);

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortField, setSortField] = useState('');
	const [sortOrder, setSortOrder] = useState('');
	const [date, setDate] = useState<any>(dayjs());

	const handleDatePicker = (value: any) => {
		setDate(value);
	};



	const tableChangeHandler = (
		pagination: TablePagination,
		filters: any,
		sorter: TableSorter
	) => {
		setTotalRecords(pagination.total);
		setCurrentPage(pagination.current);
		setPageSize(pagination.pageSize);
		let order = '';
		if (sorter?.order === 'ascend') {
			order = 'asc';
		} else if (sorter?.order) {
			order = 'desc';
		}
		setSortOrder(order);
		setSortField(sorter.field);
	};

	const fetchTimeSheets = async () => {
		try {
			setIsLoading(true);
			const timeSheets = await timeSheetsApi.getTimeSheets({
				month: Number(date['$M']) + 1,
				year: date['$y'],
			});

			setTimeSheetData(timeSheets.data.data);
			setTotalRecords(timeSheets.data.total);
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in fetching time sheets';

			toastText(errorMessage, 'error');
		} finally {
			setIsLoading(false);
		}
	};

	const refreshTimeSheets = () => {
		setCurrentPage(1);
		fetchTimeSheets();
	};

	useEffect(() => {
		fetchTimeSheets();
	}, [date, currentPage, pageSize, sortField, sortOrder]);

	return (
		<div className="modal-animation">
			<div className={styles['time-logs']}>
				<div className={styles['time-logs__header']}>
					<div className={styles['time-logs__header__title']}>
						Time Sheets
					</div>
					<div
						className={styles['time-logs__header__actions']}
						onClick={() => {
							navigate('/monthly-summary');
						}}
					>
						<CloseSvg />
					</div>
				</div>
				<div className={styles['time-logs__table']}>
					<TimeSheetsTableHeader
						handleDatePicker={handleDatePicker}
						dateValue={date}
						isLoading={isLoading}
						fetchTimeSheets={refreshTimeSheets}
					/>
					<TimeSheetsTable
						tableData={timeSheetData}
						totalRecords={totalRecords}
						currentPage={currentPage}
						pageSize={pageSize}
						tableChangeHandler={tableChangeHandler}
						isLoading={isLoading}
						fetchTimeSheets={fetchTimeSheets}
					/>
				</div>
			</div>
		</div>
	);
};

export default TimeSheetComponent;
